import { ShowToast } from "../../components/show-toast/ShowToast";
import { fetchNotificationList } from "../../redux/Slices/common/CommonSlice";

export const setupSchedulerSocket = (socket, currentUser, joCsNonOwnerInterviewReport, setInterviewToBeCompleted, setShowInterviewPopup, dispatch) => {
  const handleInterviewToBeCompleted = (data) => {
     console.log("interview_to_complete:", data);
    if (currentUser?.staff?.is_cs) {
      const isOwner = currentUser?.staff?.id === data?.cs_owner_id;
      const isNonOwnerAllowed = currentUser?.staff?.id !== data?.cs_owner_id && joCsNonOwnerInterviewReport === 'y';

      if (isOwner || isNonOwnerAllowed) {
        setInterviewToBeCompleted(data);
        setShowInterviewPopup(true);
        console.log("Received interview data:", data);
      }
    }
  };

  const handleChangeCSorInterpreter = (data) => {
    console.log("Raw data received:", data);
    if (Array.isArray(data) && data.length > 0) {
      data.forEach((item) => {
        if (item?.staff_id === currentUser?.staff?.id && item?.message) {
          console.log("Change CS or Interpreter event received:", item);
          ShowToast("success", item.message);
          dispatch(fetchNotificationList({ limit: 10, page: 1 }));
        }
      });
    }
  };

  const connectSchedulerSocket = () => {
    if (!socket.connected) {
      socket.connect();
    }
    socket.on('interviews_to_complete', handleInterviewToBeCompleted);
    socket.on('change_employer_cs', handleChangeCSorInterpreter);
    socket.on('change_worker_interpreter', handleChangeCSorInterpreter);
    socket.on('change_contract_cs', handleChangeCSorInterpreter);
    socket.on('assign_contract_cs', handleChangeCSorInterpreter);
    socket.on('job_matched', handleChangeCSorInterpreter);
    socket.on('upcoming_interview_instant', handleChangeCSorInterpreter);
    socket.on('processing_follow_up', handleChangeCSorInterpreter);
    socket.on('task', handleChangeCSorInterpreter);
    socket.on('one_month_before_contract_visa_expiry_notification_to_cs', handleChangeCSorInterpreter);
    socket.on('update_visa_reference_no_notification_to_cs', handleChangeCSorInterpreter);
    socket.on('processing_medical_file_uploaded', handleChangeCSorInterpreter);
    socket.on('insurance_effective_date_updated', handleChangeCSorInterpreter);
    socket.on('submit_policy_request', handleChangeCSorInterpreter);
    socket.on('assign_worker_interpreter', handleChangeCSorInterpreter);
    socket.on('interview_cancelled_by_worker', handleChangeCSorInterpreter);
    socket.on('worker_no_show', handleChangeCSorInterpreter);
    socket.on('interview_cancelled_by_employer_to_cs', handleChangeCSorInterpreter);
    socket.on('interview_cancelled_by_employer_to_interpreter', handleChangeCSorInterpreter);
    socket.on('interview_rescheduled_by_employer_to_interpreter', handleChangeCSorInterpreter);
    socket.on('interview_cancelled_by_admin_to_cs', handleChangeCSorInterpreter);
    socket.on('interview_cancelled_by_admin_to_interpreter', handleChangeCSorInterpreter);
    socket.on('interview_rescheduled_by_worker_to_cs', handleChangeCSorInterpreter);

    // Logs For debugging
    socket.on('connect', () => {
      console.log('Scheduler Socket connected successfully');
    });

    socket.on('disconnect', () => {
      console.log('Scheduler Socket disconnected');
    });

    socket.on('connect_error', (error) => {
      console.error('Scheduler Socket connection error:', error);
    });
  };

  const disconnectSchedulerSocket = () => {
    socket.off('interviews_to_complete', handleInterviewToBeCompleted);
    socket.off('change_employer_cs', handleChangeCSorInterpreter);
    socket.off('change_worker_interpreter', handleChangeCSorInterpreter);
    socket.off('change_contract_cs', handleChangeCSorInterpreter);
    socket.off('assign_contract_cs', handleChangeCSorInterpreter);
    socket.off('job_matched', handleChangeCSorInterpreter);
    socket.off('upcoming_interview_instant', handleChangeCSorInterpreter);
    socket.off('processing_follow_up', handleChangeCSorInterpreter);
    socket.off('task', handleChangeCSorInterpreter);
    socket.off('one_month_before_contract_visa_expiry_notification_to_cs', handleChangeCSorInterpreter);
    socket.off('update_visa_reference_no_notification_to_cs', handleChangeCSorInterpreter);
    socket.off('processing_medical_file_uploaded', handleChangeCSorInterpreter);
    socket.off('insurance_effective_date_updated', handleChangeCSorInterpreter);
    socket.off('submit_policy_request', handleChangeCSorInterpreter);
    socket.off('assign_worker_interpreter', handleChangeCSorInterpreter);
    socket.off('interview_cancelled_by_worker', handleChangeCSorInterpreter);
    socket.off('worker_no_show', handleChangeCSorInterpreter);
    socket.off('interview_cancelled_by_employer_to_cs', handleChangeCSorInterpreter);
    socket.off('interview_cancelled_by_employer_to_interpreter', handleChangeCSorInterpreter);
    socket.off('interview_rescheduled_by_employer_to_interpreter', handleChangeCSorInterpreter);
    socket.off('interview_cancelled_by_admin_to_cs', handleChangeCSorInterpreter);
    socket.off('interview_cancelled_by_admin_to_interpreter', handleChangeCSorInterpreter);
    socket.off('interview_rescheduled_by_worker_to_cs', handleChangeCSorInterpreter);
    socket.disconnect();
  };

  return {
    connectSchedulerSocket,
    disconnectSchedulerSocket
  };
};